/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Dirs_Selection_CountInputs */

const es_settings_dirs_selection_count = /** @type {(inputs: Settings_Dirs_Selection_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} seleccionada(s)`)
};

const en_settings_dirs_selection_count = /** @type {(inputs: Settings_Dirs_Selection_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Settings_Dirs_Selection_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_selection_count = /** @type {((inputs: Settings_Dirs_Selection_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Selection_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_selection_count(inputs)
	return en_settings_dirs_selection_count(inputs)
});
export { settings_dirs_selection_count as "settings.dirs.selection.count" }